import myRequest from '@/services/myRequest';

export async function queryPictureLibraryList(params) {
  return myRequest('get', '/pictureLibrary/queryList', params);
}

export async function queryPictureLibraryById(params) {
  return myRequest('get', '/pictureLibrary/queryById', params);
}

export async function addPictureLibrary(params) {
  return myRequest('post', '/pictureLibrary/add', params, { requestType: 'json' });
}

export async function updatePictureLibrary(params) {
  return myRequest('post', '/pictureLibrary/update', params, {
    requestType: 'json',
    keepEmpty: true,
  });
}

export async function deletePictureLibrary(params) {
  return myRequest('post', '/pictureLibrary/delete', params);
}

export async function updateUseNum(params) {
  return myRequest('post', '/pictureLibrary/updateUseNum', params);
}

export async function updateDownloadNum(params) {
  return myRequest('post', '/pictureLibrary/updateDownloadNum', params);
}

export async function getTags(params) {
  return myRequest('get', '/pictureLibrary/getTags', params);
}

export async function addTag(tag) {
  // Sending as plain string to match @RequestBody String tag
  return myRequest('post', '/pictureLibrary/addTag', tag, { header: { 'Content-Type': 'text/plain' } });
}

export async function deleteTag(params) {
  return myRequest('post', '/pictureLibrary/deleteTag', params);
}
